module.exports = __webpack_public_path__ + "assets/pickup-pin.dccb197c9490c5e439d6903cd7039741.svg";